import React, { lazy, Suspense, useEffect, useState } from "react";
import "./App.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import InstallPWAButton from "./InstallPWAButton";
import { API_URL } from "./services/api";
import { useUser } from "./context/UserContext";

const HomePage = lazy(() => import("./components/layout/HomePage"));
const SignInForm = lazy(() => import("./components/auth/SignInForm"));
const SignUpForm = lazy(() => import("./components/auth/SignUpForm"));

const App = () => {
  const { isLoggedIn, isLoading, login } = useUser();
  const [isSignUp, setIsSignUp] = useState(false);
    console.log(
    "Google Client ID:",
    process.env.REACT_APP_GOOGLE_CLIENT_ID
  );
  const messaging = getMessaging();

  useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  const token = params.get("token");
  const userId = params.get("userId");
  const email = params.get("email");

  if (token && userId) {
    login(userId, email || "", email || "", token, []);
  }
}, []);
  // Check and update FCM token on app start or login
  const checkAndUpdateToken = async (userId) => {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_VAPID_KEY,
      });
      const savedToken = localStorage.getItem("fcmToken");
      if (currentToken && currentToken !== savedToken) {
        localStorage.setItem("fcmToken", currentToken);
        await sendTokenToServer(currentToken, userId);
      }
    } catch (err) {
      console.error("Failed to get FCM token:", err);
    }
  };

  const sendTokenToServer = async (token, userId) => {
    if (!userId) {
      console.error("User ID not found when sending token");
      return;
    }
    try {
      await fetch(`${API_URL}/api/save-fcm-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, userId }),
      });
    } catch (err) {
      console.error("Error sending token to server:", err);
    }
  };

  // On login: persist user in context, then sync the FCM token.
  const handleLogin = async (userId, username, email, token, permissions) => {
    login(userId, username, email, token, permissions);
    await checkAndUpdateToken(userId);
  };

  // Listen for foreground messages (optional)
  useEffect(() => {
    const unsubscribe = onMessage(messaging, () => {
      // You can display a toast or notification here
    });
    return () => unsubscribe();
  }, [messaging]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data.type === "gmail-auth-success") {
        if (event.data.success) {
          alert(`Gmail access successfully configured for ${event.data.email}`);
        } else {
          alert(`Failed to configure Gmail: ${event.data.error}`);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  if (isLoading) return <div>Loading...</div>;

  function isIOS() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Suspense fallback={<div>Loading...</div>}>
        {isLoggedIn ? (
          <HomePage isIOS={isIOS} handleEnableNotifications={() => {}} />
        ) : isSignUp ? (
          <div className="login-page">
            <SignUpForm onSignInClick={() => setIsSignUp(false)} />
          </div>
        ) : (
          <div className="login-page">
            <SignInForm
              onSignUpClick={() => setIsSignUp(true)}
              onLogin={handleLogin}
            />
            {isIOS() && <InstallPWAButton />}
          </div>
        )}
      </Suspense>
    </GoogleOAuthProvider>
  );
};

export default App;
